import { render, staticRenderFns } from "./PeriodFormItem.vue?vue&type=template&id=18f5c456&scoped=true"
import script from "./PeriodFormItem.vue?vue&type=script&lang=js"
export * from "./PeriodFormItem.vue?vue&type=script&lang=js"
import style0 from "./PeriodFormItem.vue?vue&type=style&index=0&id=18f5c456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f5c456",
  null
  
)

export default component.exports